import { EdgelessElementRendererExtension } from '@blocksuite/hive/blocks/root';
import { SurfaceBlockSchema } from '@blocksuite/hive/blocks/surface';
import { MindMapView } from '@blocksuite/hive/gfx/mindmap';
import { RootBlockSchema } from '@blocksuite/hive/model';
import {
  DocModeService,
  ThemeService,
} from '@blocksuite/hive/shared/services';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/hive/std';
import type { BlockSchema, ExtensionType } from '@blocksuite/hive/store';
import { literal } from 'lit/static-html.js';
import type { z } from 'zod';

import { MindmapService } from './mindmap-service.js';
import { MindmapSurfaceBlockService } from './surface-service.js';

export const MiniMindmapSpecs: ExtensionType[] = [
  DocModeService,
  ThemeService,
  FlavourExtension('hive:page'),
  MindmapService,
  BlockViewExtension('hive:page', literal`mini-mindmap-root-block`),
  FlavourExtension('hive:surface'),
  MindMapView,
  MindmapSurfaceBlockService,
  BlockViewExtension('hive:surface', literal`mini-mindmap-surface-block`),
  ...EdgelessElementRendererExtension,
];

export const MiniMindmapSchema: z.infer<typeof BlockSchema>[] = [
  RootBlockSchema,
  SurfaceBlockSchema,
];
